var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"height":"100%","width":"100%","margin":"0","border":"0"},attrs:{"src":_vm.iframeUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }